document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form.action || !form.action.includes('/cart/add')) return;

  const trolley = document.getElementById('miniTrolley');
  const cartIcon = document.querySelector('cart-icon'); // This theme's real cart element
  if (!trolley || !cartIcon) return;

  const cartRect = cartIcon.getBoundingClientRect();

  trolley.style.transition = 'none';
  trolley.style.top = (cartRect.top + cartRect.height / 2 - 12) + 'px';
  trolley.style.left = '20px';
  trolley.style.opacity = '1';
  trolley.classList.remove('walking');
  void trolley.offsetWidth;

  requestAnimationFrame(() => {
    trolley.style.transition = 'left 1.6s ease-in-out';
    trolley.style.left = (cartRect.left - 10) + 'px';
    trolley.classList.add('walking');
  });

  setTimeout(() => {
    trolley.style.transition = 'opacity 0.3s ease';
    trolley.style.opacity = '0';
  }, 1600);
});
